import './App.css';
import StartScreen from './StartScreen';
import Footer from './Footer';

function App() {
  return (
    <div className="App">
      <div className="wrapper">
        <StartScreen />
      </div>
      <Footer />
    </div>
  );
}

export default App;
